import React from 'react';
import { Patient } from '../../types';

interface PatientListItemProps {
  patient: Patient;
  active: boolean;
  onSelect: (patient: Patient) => void;
  highlightName: (firstName: string, lastName: string) => React.ReactNode;
  tags: string[] | undefined;
}

export const PatientListItem = ({ patient, active, onSelect, highlightName, tags }: PatientListItemProps) => (
  <button
    onClick={() => onSelect(patient)}
    className={[
      'w-full text-left px-3 py-2 rounded-md mb-1 text-sm transition shadow-sm border border-transparent flex flex-col gap-0.5',
      active ? 'bg-white border-blue-300 ring-2 ring-blue-200' : 'bg-white/70 hover:bg-white hover:border-gray-200',
    ].join(' ')}
  >
    <div className='font-medium text-gray-800 truncate flex items-center gap-2'>
      <span className='truncate'>{highlightName(patient.first_name, patient.last_name)}</span>
    </div>
    <div className='flex flex-wrap gap-1'>
      {tags?.slice(0, 2).map(t => (
        <span key={t} className='text-[10px] leading-4 px-1.5 py-0.5 rounded bg-blue-50 text-blue-600 font-medium'>{t}</span>
      ))}
    </div>
  </button>
);
